import '@bcgov/bc-sans/css/BC_Sans.css';
import "../assets/stylesheets/participant.scss";

import '@hotwired/turbo-rails';
import { Application } from '@hotwired/stimulus';
import AcceptTerms from './controllers/participant/accept_terms_controller';
import Accordion from './controllers/participant/accordion_controller';
import ActiveTimer from './controllers/participant/active_timer_controller';
import ActivityIframe from './controllers/participant/activity_iframe_controller';
import CustomSelect from './controllers/participant/custom_select_controller';
import Dropdown from '@stimulus-components/dropdown';
import Dialog from '@stimulus-components/dialog';
import FlashMessages from './controllers/participant/flash_messages_controller';
import { FormDirtyConfirmNavigationController } from "stimulus-library";
import FreeFormText from './controllers/participant/free_form_text_controller';
import MobileNav from './controllers/participant/mobile_nav_controller';
import MultipleChoiceQuizTask from './controllers/participant/multiple_choice_quiz_task_controller';
import Passwords from './controllers/passwords_controller';
import Popover from './controllers/participant/popover_controller';
import ProfileJobCategory from './controllers/participant/profile_job_category_controller';
import Reflections from './controllers/participant/reflections_controller';
import SurveyTask from './controllers/participant/survey_task_controller';
import TextareaAutogrow from './controllers/participant/textarea_autogrow_controller';
import Tooltip from './controllers/participant/tooltip_controller';
import Transcript from './controllers/participant/transcript_controller';
import UserLogin from './controllers/participant/user_login_controller';

// eslint-disable-next-line no-unused-vars
import sessionMonitor from './session_monitor'; // Initialized automatically

const application = Application.start();

application.register('accept-terms', AcceptTerms);
application.register('accordion', Accordion);
application.register('active-timer', ActiveTimer);
application.register('activity-iframe', ActivityIframe);
application.register('custom-select', CustomSelect);
application.register('dropdown', Dropdown);
application.register('dialog', Dialog);
application.register('flash-messages', FlashMessages);
application.register('form-dirty-confirm-navigation', FormDirtyConfirmNavigationController);
application.register('free-form-text', FreeFormText);
application.register('mobile-nav', MobileNav);
application.register('multiple-choice-quiz-task', MultipleChoiceQuizTask);
application.register('passwords', Passwords);
application.register('popover', Popover);
application.register('profile-job-category', ProfileJobCategory);
application.register('reflections', Reflections);
application.register('survey-task', SurveyTask);
application.register('textarea-autogrow', TextareaAutogrow);
application.register('tooltip', Tooltip);
application.register('transcript', Transcript);
application.register('user-login', UserLogin);

document.addEventListener("turbo:frame-missing", async (event) => {
  const { response } = event.detail;
  const { status } = response;

  let message = "An error occurred.";
  let noticeClass = "info";
  if (status === 404) {
    // Provide a cleaner message, but let Turbo handle 404s normally
    message = "Content not found.";
    noticeClass = "warning";
  } else if (status >= 500) {
    event.preventDefault(); // Prevent Turbo's default handling, 500s will be reported on the server
    message = "Server error.";
    noticeClass = "danger";
  } else if (status === 200 && response.redirected && response.url?.endsWith("login")) {
    // 200 + redirected to login indicates session expiration
    // We might want to handle other 200s or redirects differently in the future
    event.preventDefault(); // Prevent Turbo's default handling, session expirations will be handled here
    message = "Your login session has expired.";
  }
  // By not preventing default for other status codes, we allow Turbo to handle them as usual

  message += ` Please try <a href="" target="_top">refreshing the page</a> and retrying your action.`;

  event.target.innerHTML = `<div class="notice notice-${noticeClass} notice-sm">${message}</div>`;
});
